import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
  headers: { "Content-Type": "application/json" },
});

// Attach admin token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rk_admin_token");
  if (token && config.url && config.url.startsWith("/admin")) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const submitContact = (data) => api.post("/contact", data).then((r) => r.data);
export const submitSpeaking = (data) => api.post("/speaking", data).then((r) => r.data);
export const submitAdvisory = (data) => api.post("/advisory", data).then((r) => r.data);
export const subscribeNewsletter = (data) => api.post("/newsletter", data).then((r) => r.data);

export const fetchArticles = () => api.get("/articles").then((r) => r.data);
export const fetchPodcasts = () => api.get("/podcasts").then((r) => r.data);

// Admin
export const adminLogin = (password) =>
  api.post("/admin/login", { password }).then((r) => r.data);
export const adminMe = () => api.get("/admin/me").then((r) => r.data);
export const adminListInquiries = (formType) =>
  api
    .get("/admin/inquiries", { params: formType ? { form_type: formType } : {} })
    .then((r) => r.data);
export const adminDeleteInquiry = (id) =>
  api.delete(`/admin/inquiries/${id}`).then((r) => r.data);

export const adminListArticles = () =>
  api.get("/admin/articles").then((r) => r.data);
export const adminCreateArticle = (body) =>
  api.post("/admin/articles", body).then((r) => r.data);
export const adminUpdateArticle = (id, body) =>
  api.put(`/admin/articles/${id}`, body).then((r) => r.data);
export const adminDeleteArticle = (id) =>
  api.delete(`/admin/articles/${id}`).then((r) => r.data);

export const adminListPodcasts = () =>
  api.get("/admin/podcasts").then((r) => r.data);
export const adminCreatePodcast = (body) =>
  api.post("/admin/podcasts", body).then((r) => r.data);
export const adminUpdatePodcast = (id, body) =>
  api.put(`/admin/podcasts/${id}`, body).then((r) => r.data);
export const adminDeletePodcast = (id) =>
  api.delete(`/admin/podcasts/${id}`).then((r) => r.data);

// Site images (hero portraits)
export const fetchSiteImages = () => api.get("/site/images").then((r) => r.data);
export const adminUpdateSiteImage = (key, url) =>
  api.put("/admin/site/images", { key, url }).then((r) => r.data);
export const adminResetSiteImage = (key) =>
  api.post("/admin/site/images/reset", { key }).then((r) => r.data);
export const adminUploadImage = (file) => {
  const form = new FormData();
  form.append("file", file);
  // Let axios set the multipart boundary by overriding the default JSON content-type.
  return api
    .post("/admin/uploads", form, {
      timeout: 60000,
      headers: { "Content-Type": undefined },
      transformRequest: (data) => data,
    })
    .then((r) => r.data);
};

export function extractErrorMessage(err) {
  const data = err?.response?.data;
  if (!data) return "Something went wrong. Please try again.";
  if (typeof data === "string") return data;
  if (data.detail) {
    if (typeof data.detail === "string") return data.detail;
    if (Array.isArray(data.detail)) {
      return data.detail
        .map((d) => d.msg || d.message || "Invalid input")
        .join(". ");
    }
  }
  return "Something went wrong. Please try again.";
}
